import {Step} from '../../../common/arr-stepper/ArrStepper';
import {t} from 'i18next';

export type StepKey =
  | 'basicInfo'
  | 'documentSelection'
  | 'metadataFields'
  | 'selectAnalyzers'
  | 'review';

export const STEP_KEY_BASIC_INFO: StepKey = 'basicInfo';
export const STEP_KEY_DOCUMENT_SELECTION: StepKey = 'documentSelection';
export const STEP_KEY_METADATA_FIELDS: StepKey = 'metadataFields';
export const STEP_KEY_SELECT_ANALYZERS: StepKey = 'selectAnalyzers';
export const STEP_KEY_REVIEW: StepKey = 'review';

export const indexManagementStepperItems = () => {
  return [
    {
      key: STEP_KEY_BASIC_INFO,
      label: t('indexManagement.customIndex.stepper.basicInfo'),
      state: 'current',
    },
    {
      key: STEP_KEY_DOCUMENT_SELECTION,
      label: t('indexManagement.customIndex.stepper.documentSelection'),
      state: 'future',
    },
    {
      key: STEP_KEY_METADATA_FIELDS,
      label: t('indexManagement.customIndex.stepper.metadataFields'),
      state: 'future',
    },
    {
      key: STEP_KEY_SELECT_ANALYZERS,
      label: t('indexManagement.customIndex.stepper.selectAnalyzers'),
      state: 'future',
    },
    {
      key: STEP_KEY_REVIEW,
      label: t('indexManagement.customIndex.stepper.review'),
      state: 'future',
    },
  ] as Step[];
};

export const formatUtcDateTime = (input: string) => {
  if (!input) return '';

  const date = new Date(input.endsWith('Z') ? input : `${input}Z`);

  return `${date.getUTCFullYear()}/${String(date.getUTCMonth() + 1).padStart(
    2,
    '0'
  )}/${String(date.getUTCDate()).padStart(
    2,
    '0'
  )} UTC ${String(date.getUTCHours()).padStart(2, '0')}:${String(
    date.getUTCMinutes()
  ).padStart(2, '0')}:${String(date.getUTCSeconds()).padStart(2, '0')}`;
};
